import React from "react";
import {
  FaRocket,
  FaChartLine,
  FaLightbulb,
  FaCheckCircle,
} from "react-icons/fa";
import "./CareerBenefitsForm.css";
import Enquire_form from "../../common/enquire_form/Enquire_form";

function CareerBenefitsForm({
  onApplicationSuccess,
  register,
  handleSubmit,
  reset,
  setValue,
  getValues,
  control,
  errors,
  watch,
}) {
  return (
    <div className="career-benefits-form-wrapper mt-4">
      <div className="row align-items-stretch gy-4">
        {/* Left Side: Value Proposition & Perks */}
        <div className="col-lg-6 d-flex flex-column justify-content-center pe-lg-5">
          <div className="why-join-content">
            <span className="text-overline">BUILD YOUR FUTURE</span>
            <h2 className="section-title-highlight mb-4">
              Why Join Our Elite Team?
            </h2>
            <p className="section-description mb-4">
              We look beyond standard resumes. We look for passionate builders,
              problem solvers, and creative thinkers eager to push technology to
              its absolute limit.
            </p>

            {/* Feature grid blocks */}
            <div className="benefit-card mb-3">
              <div className="icon-wrapper">
                <FaRocket />
              </div>
              <div>
                <h5>Supportive Environment</h5>
                <p>
                  Work alongside friendly, industry-leading experts in a
                  stress-free culture built on collaborative growth.
                </p>
              </div>
            </div>

            <div className="benefit-card mb-3">
              <div className="icon-wrapper">
                <FaChartLine />
              </div>
              <div>
                <h5>Accelerated Career Path</h5>
                <p>
                  Clear milestones, internal promotions, and continuous
                  learning/certification budgets assigned to you.
                </p>
              </div>
            </div>

            <div className="benefit-card mb-4">
              <div className="icon-wrapper">
                <FaLightbulb />
              </div>
              <div>
                <h5>Competitive Compensation</h5>
                <p>
                  Top-tier salary matching, health incentives, flexible remote
                  options, and performance-driven bonuses.
                </p>
              </div>
            </div>

            {/* Bulleted checklist micro-perks */}
            <div className="quick-perks">
              <div className="perk-item">
                <FaCheckCircle className="check-icon" /> Flexible Hours
              </div>
              <div className="perk-item">
                <FaCheckCircle className="check-icon" /> Continuous Mentorship
              </div>
              <div className="perk-item">
                <FaCheckCircle className="check-icon" /> Cutting-Edge Projects
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Form Container Block */}
        <div className="col-lg-6">
          <div className="form-glass-container">
            <div className="form-header-badge">
              <h4>Apply Now / Submit Query</h4>
              <p>
                Fill out the file application blueprint below to immediately
                trigger an introductory screening.
              </p>
            </div>

            <Enquire_form
              show={true}
              handleClose={() => {}}
              onSuccessSubmit={onApplicationSuccess}
              register={register}
              handleSubmit={handleSubmit}
              reset={reset}
              setValue={setValue}
              getValues={getValues}
              control={control}
              errors={errors}
              watch={watch}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CareerBenefitsForm;
